<div class="row">
     <div class="col-12">
         <div class="row justify-content-between align-items-center" id="page-title">
             <h1 class="progress-header col-12 col-lg-auto">
                 {{ 'Enroll in PSP_MAIN' | translator:'base' }}
             </h1>
         </div>
         <div class="row mb-2">
             <span class="col-12 col-lg-auto d-flex align-items-center small">
                 <i class="fas fa-triangle-exclamation me-2"aria-hidden="true"></i>
                 <span [innerHTML]="'Start_8-1' | translator:'base'">
                     Are you a <strong>driver</strong> looking for your own PSP record?
                 </span>
                 <a routerLink="/driver/1"
                     (click)="scrollToTop()"
                     name="Driver-record-request"
                     id="Driver-record-request"
                     [title]="'Start_8-2' | translator:'base'" 
                     class="ms-1" 
                 >
                     <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
                 </a>
             </span>
         </div>
         <div class="row">
             <div class="col-lg-8">
                 <div class="card shadow-sm rounded-0 border-0">
                     <div class="card-body">
                         <app-complete-bar [step]="6" [totalSteps]="19"></app-complete-bar>
                         <h2 [innerHTML]="'MACP46_1' | translator:'base'">
                             MONTHLY ACCOUNT HOLDER
                         </h2>
                         <p>
                             <span [innerHTML]="'MACP46_2' | translator:'base'">
                                 Let's hear more about the monthly account holder
                             </span>
                         </p>
                         <hr>
                         <div class="mb-3">
                             <label class="form-label" for="PowerUnits">
                                 <span [innerHTML]="'MACP46_2_a' | translator:'base'">
                                     How many power units (i.e., tractors) do you operate?
                                 </span>
                                 <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                             </label>
                             <br />
                             <input type="number" (keyup)="testPowerNumber()" (change)="testPowerNumber()" [(ngModel)]="enrollmentService.newCustomer!.numberOfPowerUnits" name="PowerUnits" id="PowerUnits"
                                 size="30" min="0" pattern="^[0-9]*$"
                                 class="form-control bg-light input-number" maxlength="10" />
                            <span
                                 class="help-block text-danger"
                                 *ngIf="powerInvalid === 'lthaneto' || powerInvalid === 'gthaneto'"
                                 [innerHTML]="'MACP46_3_lessthan' | translator:'base'"
                             >
                                Value must be less than or equal to 1000000000.
                             </span>
                            <span
                                 class="help-block text-danger"
                                 *ngIf="powerInvalid === 'notNumber'"
                                 [innerHTML]="'MACP46_3_invalid' | translator:'base'"
                             >
                                 Power Units can only be numbers.
                             </span>
                             <span
                                 class="help-block text-danger"
                                 *ngIf="powerInvalid === 'required'"
                                 [innerHTML]="'MACP46_3_required' | translator:'base'"
                             >
                                 Power Units is required.
                             </span>
                         </div>
                         <fieldset class="">
                             <legend class="form-label">
                                 <span [innerHTML]="'MACP46_3' | translator:'base'">Do you operate in more than one state?</span>
                                 <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                             </legend>
                             <div class="form-check">
                                 <label class="form-check-label">
                                     <input type="radio" name="interIntraState" id="Intrastate" class="form-check-input"
                                         value="Interstate" [(ngModel)]="enrollmentService.newCustomer!.interIntraState" />
                                     <span [innerHTML]="'MACP46_4' | translator:'base'">Yes, I am an interstate carrier</span>
                                 </label>
                             </div>
                             <div class="form-check">
                                 <label class="form-check-label">
                                     <input type="radio" name="interIntraState" id="Interstate" class="form-check-input"
                                         value="Intrastate" [(ngModel)]="enrollmentService.newCustomer!.interIntraState" />
                                     <span [innerHTML]="'MACP46_5' | translator:'base'"> No, I am an intrastate carrier</span>
                                 </label>
                             </div>
                         </fieldset>
                         <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                             <div class="btn-group" role="group">
                                 <button routerLink="/signup/11" tag="button" class="btn btn-primary btn-strong"
                                     [title]="'MAHInfo' | translator:'base'" [disabled]="pageValid()"
                                     (click)="scrollToTop()" name="companyNext10" id="companyNext10">
                                     <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                                     <span class="sr-only">&nbsp;</span>
                                     <span class="sr-only" [innerHTML]="'MAHInfo' | translator:'base'"></span>
                                 </button>
                             </div>
                             <div class="btn-group" role="group">
                                 <button [routerLink]="enrollmentService.newCustomer!.customerType == customerType.AH  ? '/signup/8' : '/signup/6'" tag="button" class="btn btn-outline-primary"
                                     [title]="'MAHInfo' | translator:'base'" name="companyBack10" id="companyBack10"
                                     (click)="scrollToTop()">
                                     <span [innerHTML]="'Back' | translator:'base'">Back</span>
                                     <span class="sr-only" [innerHTML]="'MAHInfo' | translator:'base'"></span>
                                 </button>
                                 <button routerLink="/" tag="button" class="btn btn-light" (click)="scrollToTop()"
                                     name="companyCancel10" id="companyCancel10" [innerHTML]="'Cancel' | translator:'base'"
                                     [title]="'Cancel' | translator:'base'">
                                     Cancel
                                 </button>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
             <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="2"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
         </div>
     </div>
 </div>
 
 
